<p-panel>
    <ng-template pTemplate="header">
        <div class="header d-flex justify-content-between align-items-center w-100">
            <span>{{ 'IRONSIDE.news-detail-dialog.YELLOW_FOCUS' | translate }}</span>
            <button mat-dialog-close type="button" class="close-button">
                <i class="pi pi-times"></i>
            </button>
        </div>
    </ng-template>
    <div class="popup-news">
        <p class="title-news font-bold">{{ news?.title | translateDynamicLanguage }}</p>
        <div class="popup-content d-flex">
            <div class="d-flex wrap-img w-50 h-50" style="justify-content: center">
                <img *ngIf="news?.imageURL" [src]="news?.imageURL" alt="news-detail-image" />
                <p-skeleton *ngIf="!news?.imageURL" width="100%" height="100%"></p-skeleton>
                <!--news.images[0] -->
            </div>
            <div class="wrap-content w-50">
                <p class="description">
                    {{ news?.description | translateDynamicLanguage }}
                </p>
                <div class="wrap-anchor d-flex align-items-center gap-3">
                    <div class="wrap-file w-6 p-2">
                        <a style="cursor: pointer" class="d-flex align-items-center gap-3" (click)="openFile(news)"
                            target="_blank">
                            <img src="src-ironside/assets/icons/file-text.svg" alt="" />
                            <div class="wrap-text">
                                <p class="mb-0 font-bold">
                                    {{ 'IRONSIDE.news-detail-dialog.ATTACHMENT' | translate }}
                                </p>
                                <p class="mb-0 line-clamp-2">{{ getNameFile(news) }}</p>
                            </div>
                        </a>
                    </div>
                    <!-- <a class="a-link w-6" target="_blank" [href]="news?.document?.[0]?.url">Lien hypertexte</a> -->
                </div>
            </div>
        </div>
    </div>
</p-panel>

<p-dialog header="{{ 'IRONSIDE.news-detail-dialog.FILE_PREVIEW' | translate }}" [modal]="true" [(visible)]="visibleItem"
    [style]="{ width: '70%' }">
    <div class="popup-del-row">
        <div class="w-100 text-end" style="margin-bottom: 12px">
            <a href="{{ itemPdfShow?.urlFile }}" class="btn-common p-2">{{
                'IRONSIDE.news-detail-dialog.DOWNLOAD' | translate
                }}</a>
        </div>
        <div id="outerContainer" *ngIf="this.itemPdfShow?.urlFile" class="pdf-viewer-container">
            <div class="pdf-container" [ngClass]="{ loaded: pdfLoaded }">
                <ng-container *ngIf="typeFile === 'pdf'; else elseTemplate">
                    <pdf-viewer [src]="itemPdfShow?.urlFile" [rotation]="0" [original-size]="false" [show-all]="true"
                        [fit-to-page]="false" [zoom]="1" [zoom-scale]="'page-width'" [stick-to-page]="false"
                        [render-text]="true" [external-link-target]="'blank'" [autoresize]="true" [show-borders]="false"
                        style="max-width: 100%; width: 100%; height: 80vh" (page-rendered)="pageRendered($event)"
                        (after-load-complete)="pageProgress($event)"></pdf-viewer>
                </ng-container>
                <ng-template #elseTemplate>
                    <div style="width: 100%; text-align: center">
                        <img [src]="itemPdfShow?.urlFile" alt="" style="max-width: 100%; height: auto;" />
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</p-dialog>